import React, {useEffect, useImperativeHandle, useRef, useState} from "react";
const classnames = require('classnames');
require('intersection-observer');

interface FixedTabsProps{
    tabs:Array<string>,
    onChange:(index:number) => void,
    autoFixed?:boolean,
    active?:number,
    ref?:React.Ref<any>,
}

const FixedTabs:React.FC<FixedTabsProps> = React.forwardRef((props,ref) => {
    const [active,setActive] = useState(props.active || 0)
    const [height,setHeight] = useState(0)
    const [fixed,setFix] = useState(!props.autoFixed)
    const boxRef = useRef(null)
    const wrapRef = useRef(null)

    const changeHandle = (index:number) => {
        setActive(index)
        props.onChange(index)
    }

    useImperativeHandle(ref,() => ({
        setActiveTab:(n:number) => {
            changeHandle(n)
        }
    }))

    useEffect(() => {
        if(boxRef){
            setTimeout(() => {
                // @ts-ignore
                setHeight(boxRef.current.getBoundingClientRect().height)
            },200)

        }
    },[props.tabs])

    useEffect(() => {
        if(props.autoFixed){
            const io = new IntersectionObserver(entries => {
                const rect = entries[0].boundingClientRect
                // console.log(rect.top)
                if(rect.top < 0){
                    setFix(true)
                }else{
                    setFix(false)
                }
            },{
                threshold:1.0
            })

            // @ts-ignore
            io.observe(wrapRef.current)

            return () => {
                // @ts-ignore
                io.unobserve(wrapRef.current)
                io.disconnect()
            }
        }
    },[])

    return <div style={{ height:`${height}px` ,minHeight:'.9rem'}} ref={ wrapRef }>
        <div className={classnames("fixed-tabs",{ 'active' : fixed })} ref={boxRef}>
            {
                props.tabs.map((item,index) => {
                    return <div className={classnames("item",{'active':index === active})} key={ index } onClick={ () => changeHandle(index) }>{ item }</div>
                })
            }
        </div>
    </div>
})

export default FixedTabs
